module.exports = __webpack_public_path__ + "static/media/lilliannguyen.95fd5e56.jpeg";